import { ModalEyebrowProps } from '@/components/ui/Modal/ModalEyebrow';

export const addToYourSearchEyebrow: ModalEyebrowProps = {
  text: 'Added to your search',
  icon: 'check'
};
